var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_c('img',{attrs:{"src":require("../assets/img/logo.png"),"alt":""}}),_c('p',[_vm._v("鼎函统一登录入口"+_vm._s(_vm.environmentName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }